module.exports = __webpack_public_path__ + "static/media/_MIC2463.image.36b394a7.png";